import { STORY_CONFIG, type StoryBiomeId } from "../story/storyConfig";
import { ChampionPulseSystem } from "./ChampionPulseSystem";
import { SpiritPressureSystem } from "./SpiritPressureSystem";

export class EnvironmentalStoryBeatSystem {
  private lastBiome?: StoryBiomeId;
  private cooldown = 0;

  reset() {
    this.lastBiome = undefined;
    this.cooldown = 0;
  }

  update(dt: number, biome: StoryBiomeId, progress: number, spirit: SpiritPressureSystem, champion: ChampionPulseSystem) {
    this.cooldown = Math.max(0, this.cooldown - dt);
    if (this.lastBiome !== biome) {
      this.lastBiome = biome;
      if (this.cooldown <= 0) {
        this.cooldown = STORY_CONFIG.storyBeats.minSecondsBetweenBeats;
        if (biome === "corrupted_pressure_zone" || biome === "final_spirit_chase" || biome === "ancient_ruins") {
          spirit.pulse();
        }
        if (biome === "final_spirit_chase" || progress > 0.78) {
          champion.trigger();
        }
        return STORY_CONFIG.storyBeats.hints[biome];
      }
    }
    return null;
  }
}
